import { TFunction } from 'i18next'
import { getIsRenewalCancelled } from './getIsRenewalCancelled'

type Input = {
  row: {
    rejected: boolean
    paused?: boolean
    pausedAt?: string | null
    shouldRenew?: boolean | null
    totalStages?: number
    completedStages?: number
    stage?: string[]
  }
  t: TFunction
}

type Output = {
  firstItem: string
  currentSteps?: string[]
  currentStepsJoined?: string
}

export const getStageValueTranslationString = ({
  row: { rejected, paused, pausedAt, shouldRenew, totalStages, completedStages, stage },
  t,
}: Input): Output => {
  if (rejected) {
    return { firstItem: t('table.stage.rejected') }
  }

  if (paused) {
    return { firstItem: t('table.stage.paused', { pausedAt }) }
  }

  const isCompleted = Boolean(completedStages && totalStages && completedStages === totalStages)

  const isRenewalCancelled = getIsRenewalCancelled({ isCompleted, shouldRenew })

  if (isRenewalCancelled) {
    return { firstItem: t('table.stage.cancelled') }
  }

  if (isCompleted) {
    return { firstItem: t('table.stage.completed') }
  }

  const currentSteps = stage || []
  const firstItem = currentSteps[0] || ''

  return {
    firstItem,
    currentSteps,
    currentStepsJoined: currentSteps.join(', '),
  }
}
